import { s } from '../lib/sx'
import { PageHero } from '../components/PageHero'
import { copy } from '../content/copy'
import { certifications, environmentalNote, safetyIntro, safetyPractices, safetyStats } from '../content/safety'

export function Safety() {
  return (
    <div>
      <PageHero eyebrow="Safety & compliance" title={copy.safety.headline} />

      <section style={s('background:#1F5C99;color:#FFFFFF;')}>
        <div style={s('max-width:1320px;margin:0 auto;padding:48px clamp(18px,4vw,32px);display:grid;grid-template-columns:repeat(auto-fit,minmax(min(100%,180px),1fr));gap:32px;')}>
          {safetyStats.map((st, i) => (
            <div key={i}>
              <div style={s('font-family:Archivo,sans-serif;font-weight:800;font-size:40px;letter-spacing:-0.03em;')}>{st.value}</div>
              <div style={s("font-family:'IBM Plex Mono',monospace;font-size:11px;letter-spacing:0.14em;text-transform:uppercase;margin-top:8px;opacity:0.9;")}>{st.label}</div>
            </div>
          ))}
        </div>
      </section>

      <section style={s('max-width:1320px;margin:0 auto;padding:clamp(48px,7vw,96px) clamp(18px,4vw,32px);display:grid;grid-template-columns:repeat(auto-fit,minmax(min(100%,320px),1fr));gap:clamp(40px,5vw,72px);')}>
        <div>
          <h2 style={s('font-family:Archivo,sans-serif;font-weight:700;font-size:clamp(24px,3vw,32px);letter-spacing:-0.025em;margin:0 0 20px;')}>{copy.safety.systemHeading}</h2>
          <p style={s('font-size:16px;line-height:1.7;color:#566070;margin:0 0 28px;')}>{safetyIntro}</p>
          <div style={s('display:flex;flex-direction:column;gap:0;border-top:1px solid #DCE0E5;')}>
            {safetyPractices.map((p) => (
              <div key={p.no} style={s('display:flex;gap:18px;padding:18px 0;border-bottom:1px solid #DCE0E5;')}>
                <span style={s("font-family:'IBM Plex Mono',monospace;font-size:11px;color:#A8500F;padding-top:3px;")}>{p.no}</span>
                <span style={s('font-size:15px;line-height:1.6;color:#1B2430;')}>{p.text}</span>
              </div>
            ))}
          </div>
        </div>

        <div>
          <h2 style={s('font-family:Archivo,sans-serif;font-weight:700;font-size:clamp(24px,3vw,32px);letter-spacing:-0.025em;margin:0 0 20px;')}>{copy.safety.certHeading}</h2>
          <div style={s('display:grid;grid-template-columns:repeat(auto-fit,minmax(min(100%,240px),1fr));gap:1px;background:#DCE0E5;border:1px solid #DCE0E5;')}>
            {certifications.map((c, i) => (
              <div key={i} style={s('background:#F2F4F6;padding:26px 24px;')}>
                <div style={s('font-family:Archivo,sans-serif;font-weight:700;font-size:16px;')}>{c.name}</div>
                <div style={s('font-size:13.5px;line-height:1.6;color:#66707C;margin-top:8px;')}>{c.note}</div>
              </div>
            ))}
          </div>
          <div style={s('background:#1B2430;color:#F2F4F6;padding:clamp(18px,4vw,32px) 30px;margin-top:1px;')}>
            <div style={s("font-family:'IBM Plex Mono',monospace;font-size:10.5px;letter-spacing:0.18em;text-transform:uppercase;color:#E06A20;")}>Environmental</div>
            <p style={s('font-size:15px;line-height:1.7;color:#B8C0CA;margin:14px 0 0;')}>{environmentalNote}</p>
          </div>
        </div>
      </section>
    </div>
  )
}
